var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSbt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 62,
    viewBox: "0 0 107 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2387_2542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7477 5.07559L4.60887 23.1392C0.310875 27.4194 0.310875 34.3589 4.60887 38.6391L22.7477 56.7027C27.0457 60.9829 34.0142 60.9829 38.3122 56.7027L56.451 38.6391C60.749 34.3589 60.749 27.4194 56.451 23.1392L38.3122 5.07559C34.0142 0.79542 27.0457 0.795419 22.7477 5.07559Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7477 5.07559L4.60887 23.1392C0.310875 27.4194 0.310875 34.3589 4.60887 38.6391L22.7477 56.7027C27.0457 60.9829 34.0142 60.9829 38.3122 56.7027L56.451 38.6391C60.749 34.3589 60.749 27.4194 56.451 23.1392L38.3122 5.07559C34.0142 0.79542 27.0457 0.795419 22.7477 5.07559Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5386 23.5273V38.2791C20.5386 39.7006 21.6958 40.853 23.1232 40.853H37.9365C39.364 40.853 40.5212 39.7006 40.5212 38.2791V23.5273C40.5212 22.1057 39.364 20.9533 37.9365 20.9533H23.1232C21.6958 20.9533 20.5386 22.1057 20.5386 23.5273Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6372 17.4384C55.5286 8.24962 65.2559 1.99463 76.4284 1.99463C92.5479 1.99463 105.61 15.0028 105.61 31.0554C105.61 47.1081 92.5479 60.1162 76.4284 60.1162C65.2559 60.1162 55.5286 53.8612 50.6372 44.6725",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6787 36.3417C81.7593 36.3417 85.8779 32.2401 85.8779 27.1806C85.8779 22.1211 81.7593 18.0195 76.6787 18.0195C71.5981 18.0195 67.4795 22.1211 67.4795 27.1806C67.4795 32.2401 71.5981 36.3417 76.6787 36.3417Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9075 56.2691C88.9075 49.4052 83.3213 43.8145 76.401 43.8145C69.4808 43.8145 63.8945 49.3775 63.8945 56.2691",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2387_2542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 61,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbt);
export default __webpack_public_path__ + "static/media/sbt.c7c01c04a67ac7cae2e62dfdc976d681.svg";
export { ForwardRef as ReactComponent };